// @ts-strict-ignore
import { Box } from "@saleor/macaw-ui-next";
import React from "react";

import defaultIllustration from "../../../../assets/images/empty-metadata.svg";

type EmptyStateProps = {
  message: string;
  illustrationSrc?: string;
  alt?: string;
  compact?: boolean;
};

export const EmptyState: React.FC<EmptyStateProps> = ({
  message,
  illustrationSrc = defaultIllustration,
  alt = "Empty",
  compact,
}) => {
  // Sizes tuned for tiles; compact squeezes the image further
  const imgSize = compact ? 72 : 100;

  return (
    <Box as="div" display="flex" flexDirection="column" alignItems="center" justifyContent="center" padding={6} gap={4} color="default2" width="100%">
      <img src={illustrationSrc} alt={alt} style={{ width: imgSize, height: imgSize, opacity: 0.7 }} />
      <Box as="div" textAlign="center">{message}</Box>
    </Box>
  );
};
